import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CNPJService from '../../../services/cnpjService';
import { getTranslations } from '../../../services/languageUtils';

class PersonalCompanySection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
            translations: {},
        };
    }

    loadTranslations = async () => {
        const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
        this.setState({ translations });
    };

    componentDidMount() {
        this.loadTranslations();
    }

    searchCNPJ = (e) => {
        let cnpj = { cnpj: e.target.value.replace(/\D/g, '') };
        if (cnpj.cnpj.length === 14) {
            CNPJService.searchCNPJ(cnpj.cnpj).then((res) => {
                if (res.data && res.data.status === 'OK') {
                    this.props.onChange('tradingName', res.data['NOME FANTASIA']);
                    this.props.onChange('businessName', res.data['RAZAO SOCIAL']);
                }
            }).catch((error) => {
                console.error('Erro ao buscar CNPJ:', error);
            })
        }
    }

    maskCNPJ = (value) => {
        let returnValue = value.replace(/\D/g, "");
        if (returnValue.length > 12) {
            returnValue = returnValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2}).*/, "$1.$2.$3/$4-$5");
        }
        else if (returnValue.length > 9) {
            returnValue = returnValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{0,4}).*/, "$1.$2.$3/$4");
        }
        else if (returnValue.length > 6) {
            returnValue = returnValue.replace(/^(\d{2})(\d{3})(\d{0,3})/, "$1.$2.$3");
        }
        else if (returnValue.length > 3) {
            returnValue = returnValue.replace(/^(\d{2})(\d{0,3})/, "$1.$2");
        }
        return returnValue;
    };

    maskPhone = (value) => {
        let returnValue = value.replace(/\D/g, "");
        if (returnValue.length > 10) {
            returnValue = returnValue.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
        }
        else if (returnValue.length > 6) {
            returnValue = returnValue.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        }
        else if (returnValue.length > 2) {
            returnValue = returnValue.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
        }
        return returnValue;
    };

    handleChange = (fieldName, value) => {
        if (fieldName === 'doc') {
            const maskedValue = this.maskCNPJ(value);
            this.props.onChange(fieldName, maskedValue);
            this.searchCNPJ({ target: { value: maskedValue } });
        } else if (fieldName === 'contactNumber') {
            const maskedValue = this.maskPhone(value);
            this.props.onChange(fieldName, maskedValue);
        } else {
            this.props.onChange(fieldName, value);
        }
    };

    handleNext = () => {
        this.props.onNext();
    };

    render() {
        const { data, errors, isLoading } = this.props;
        const { showPassword, translations } = this.state;

        return (
            <div className="sideRightContent">
                <ToastContainer />
                <div className="textContentSteps">
                    <div className="h1">
                        <div className="h1Label">
                            <img src={require("../../../assets/imgs/ico-higher-titulo.svg").default} alt="Logo Higher" className="titleImage"/>
                        </div>
                        <div className="h1LabelMobile">
                            1
                        </div>
                        Dados da Empresa
                    </div>
                    <br/>

                    <p className="h5">Preencha os dados da sua empresa</p>

                    <div className="contentInputText">
                        <p className="label">Nome do Responsável</p>
                        <input 
                            className={"input " + (errors.name ? "inputDanger" : "")} 
                            value={data.name} 
                            type="text" 
                            onChange={(e) => this.handleChange('name', e.target.value)}
                            maxLength="200"
                            placeholder="Nome completo do responsável"
                        />
                        {errors.name && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.name}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">E-mail de cadastro</p>
                        <input 
                            className={"input " + (errors.email ? "inputDanger" : "")} 
                            value={data.email} 
                            type="email" 
                            onChange={(e) => this.handleChange('email', e.target.value)}
                            maxLength="150"
                            placeholder="seu@email.com"
                        />
                        {errors.email && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.email}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">CNPJ</p>
                        <input 
                            inputMode="numeric"
                            className={"input " + (errors.doc ? "inputDanger" : "")} 
                            value={data.doc} 
                            type="text" 
                            onChange={(e) => this.handleChange('doc', e.target.value)}
                            placeholder="00.000.000/0000-00"
                            maxLength="18"
                        />
                        {errors.doc && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.doc}</span>}
                    </div>

                    <div className="contentInputs contentInputSmall" style={{minWidth: "290px", margin: "0px"}}>
                        <p className="label">Tipo de Empresa</p>
                        <select 
                            className={"select " + (errors.companyType ? "inputDanger" : "")} 
                            value={data.companyType} 
                            onChange={(e) => this.handleChange('companyType', e.target.value)}
                        >
                            <option value="">Selecione o tipo</option>
                            <option value="MEI">MEI - Microempreendedor Individual</option>
                            <option value="ME">ME - Microempresa</option>
                            <option value="EPP">EPP - Empresa de Pequeno Porte</option>
                            <option value="LTDA">LTDA - Sociedade Limitada</option>
                            <option value="SA">SA - Sociedade Anônima</option>
                            <option value="EIRELI">EIRELI - Empresa Individual</option>
                        </select>
                        {errors.companyType && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.companyType}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Nome Fantasia</p>
                        <input 
                            className={"input " + (errors.tradingName ? "inputDanger" : "")} 
                            value={data.tradingName} 
                            type="text" 
                            onChange={(e) => this.handleChange('tradingName', e.target.value)}
                            maxLength="100"
                            placeholder="Nome fantasia da empresa"
                        />
                        {errors.tradingName && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.tradingName}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Razão Social</p>
                        <input 
                            className={"input " + (errors.businessName ? "inputDanger" : "")} 
                            value={data.businessName} 
                            type="text" 
                            onChange={(e) => this.handleChange('businessName', e.target.value)}
                            placeholder="Razão social da empresa"
                        />
                        {errors.businessName && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.businessName}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Site</p>
                        <input 
                            className={"input " + (errors.site ? "inputDanger" : "")} 
                            value={data.site} 
                            type="text" 
                            onChange={(e) => this.handleChange('site', e.target.value)}
                            placeholder="Site da empresa"
                        />
                        {errors.site && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.site}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Tipo de cadastro</p>
                        <select 
                            className={"select " + (errors.registerType ? "inputDanger" : "")}
                            value={data.registerType}
                            onChange={(e) => this.handleChange('registerType', e.target.value)}
                        >
                            <option value="BaaS">BaaS</option>
                            <option value="OTC">OTC</option>
                        </select>
                        {errors.registerType && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.registerType}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Wallet (OTC)</p>
                        <input 
                            className={"input " + (errors.wallet ? "inputDanger" : "")} 
                            value={data.wallet} 
                            type="text" 
                            onChange={(e) => this.handleChange('wallet', e.target.value)}
                            placeholder="Endereço da Wallet"
                        />
                        {errors.wallet && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.wallet}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Domicilio Bancário</p>
                        <input 
                            className={"input " + (errors.domicilioBancario ? "inputDanger" : "")} 
                            value={data.domicilioBancario} 
                            type="text" 
                            onChange={(e) => this.handleChange('domicilioBancario', e.target.value)}
                            placeholder="Domicilio bancário"
                        />
                        {errors.domicilioBancario && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.domicilioBancario}</span>}
                    </div>

                    <br/><br/>
                    <p className="h5">Contato</p>

                    <div className="contentInputText" style={{maxWidth: "150px"}}>
                        <p className="label">Telefone de Contato</p>
                        <input 
                            inputMode="text"
                            className={"input " + (errors.contactNumber ? "inputDanger" : "")} 
                            value={data.contactNumber} 
                            type="text" 
                            onChange={(e) => this.handleChange('contactNumber', e.target.value)}
                            maxLength="15"
                            placeholder="(11) 99999-9999"
                        />
                        {errors.contactNumber && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.contactNumber}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Senha de Acesso</p>
                        <div style={{ position: 'relative' }}>
                            <input 
                                className={"input " + (errors.password ? "inputDanger" : "")} 
                                value={data.password} 
                                type={showPassword ? 'text' : 'password'}
                                onChange={(e) => this.handleChange('password', e.target.value)}
                                placeholder="Mínimo 8 caracteres"
                                style={{ paddingRight: '40px' }}
                            />
                            <img
                                src={require(showPassword ? "../../../assets/imgs/open-eye.svg" : "../../../assets/imgs/close-eye.svg").default}
                                alt="Toggle password"
                                onClick={() => this.setState({ showPassword: !showPassword })}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    width: '20px',
                                    height: '20px'
                                }}
                            />
                        </div>
                        {errors.password && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.password}</span>}
                    </div>

                    <div className="lineBtnSaveAndContinue">
                        <div></div>
                        <div 
                            className="btnSaveAndContinue" 
                            onClick={!isLoading ? this.handleNext : undefined}
                            style={{
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                width: '300px'
                            }}
                        >
                            {isLoading ? 'Carregando...' : 'Continuar para Endereço'}
                            {!isLoading && (
                                <div className="arrow">
                                    <img 
                                        src={require("../../../assets/imgs/seta-right-branca.svg").default} 
                                        alt="Próximo" 
                                        className="arrowNext"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PersonalCompanySection;